import api from "../../components/axiosComp";
const VENUE_PUBLIC_BOOKING_FLOW = "venuePublic";

export async function getPublicVenueBySubdomain(subdomain) {
  const { data } = await api.get(
    `/api/venues/by-subdomain/${encodeURIComponent(subdomain)}`,
  );

  return {
    venue: data?.venue || null,
    grounds: Array.isArray(data?.grounds) ? data.grounds : [],
  };
}

export async function getPublicVenue(slug) {
  const { data } = await api.get(`/api/venues/${slug}`);
  return {
    venue: data?.venue || null,
    grounds: Array.isArray(data?.grounds) ? data.grounds : [],
  };
}

export async function getPublicGroundCalendar(slug, groundId, month, tz) {
  const { data } = await api.get(
    `/api/venues/${slug}/grounds/${groundId}/calendar`,
    {
      params: { month, tz },
    }
  );
  return data;
}

export async function getPublicGroundSlots(slug, groundId, date, slotSize = 60, timezone) {
  const { data } = await api.get(
    `/api/venues/${slug}/grounds/${groundId}/slots`,
    {
      params: { date, slotSize, timezone, tz: timezone },
    }
  );
  return data;
}
export async function previewPublicBookingPromo(slug, payload, params = {}) {
  const { data } = await api.post(
    `/api/venues/${slug}/bookings/promo-preview`,
    payload,
    {
      params: {
        ...params,
        bookingFlow: VENUE_PUBLIC_BOOKING_FLOW,
      },
    },
  );

  return data;
}

export async function createPublicBookingHold(slug, payload, params = {}) {
  const { data } = await api.post(`/api/venues/${slug}/bookings`, payload, {
    params: {
      ...params,
      bookingFlow: VENUE_PUBLIC_BOOKING_FLOW,
    },
  });

  return data;
}

export async function getPublicBookingConfirmation(
  slug,
  reservationId,
  confirmationToken,
) {
  const { data } = await api.post(
    `/api/venues/${slug}/bookings/${reservationId}/confirmation`,
    { confirmationToken },
  );

  return data;
}

export async function releasePublicBookingHold(
  slug,
  reservationId,
  releaseToken,
) {
  const { data } = await api.delete(
    `/api/venues/${slug}/bookings/${reservationId}/hold`,
    {
      data: { releaseToken },
    },
  );

  return data;
}

export async function abandonPublicEsewaPayment(
  slug,
  reservationId,
  releaseToken,
) {
  const { data } = await api.post(
    `/api/venues/${slug}/bookings/${reservationId}/abandon-esewa`,
    { releaseToken },
  );

  return data;
}

export async function abandonPublicRazorpayPayment(
  slug,
  reservationId,
  releaseToken,
) {
  const { data } = await api.post(
    `/api/venues/${slug}/bookings/${reservationId}/abandon-razorpay`,
    { releaseToken },
  );

  return data;
}

export async function getPublicEsewaPaymentStatus(
  slug,
  reservationId,
  releaseToken,
) {
  const { data } = await api.post(
    `/api/venues/${slug}/bookings/${reservationId}/payment-status`,
    {
      releaseToken,
    },
  );

  return data;
}

export async function createReservationPaymentOrder(reservationId) {
  const { data } = await api.post(
    `/api/reservations/${reservationId}/pay`,
  );

  return data;
}


export async function verifyReservationRazorpayPayment(payload) {
  const { data } = await api.post(
    "/api/bookings/razorPay/verifyPayment",
    payload,
  );

  return data;
}

export async function createEsewaWebV2PaymentOrder(reservationId) {
  const { data } = await api.post(
    `/api/reservations/${reservationId}/pay/esewa-web-v2`,
  );

  return data;
}